<template>
  <div v-if="$auth.ready()">
    <LoggedIn v-if="$auth.check()">
      <slot />
    </LoggedIn>

    <LoggedOut v-if="!$auth.check()">
      <slot />
    </LoggedOut>

    <Modals />
  </div>
</template>

<script>
export default {
  components: {
    LoggedIn: () => import('@/components/layout/layouts/LoggedIn'),
    LoggedOut: () => import('@/components/layout/layouts/LoggedOut'),
    Modals: () => import('@/components/Modals'),
  },
};
</script>

<style>

@import '../../../assets/css/general.css';
@import '../../../assets/css/plugins.css';
/* @import './assets/css/profile-edit.css'; */

/* @import url('https://fonts.googleapis.com/css?family=Fira+Sans+Condensed'); */
/* @import url('https://fonts.googleapis.com/css?family=Muli:300,300italic,400,600i,700'); */

@font-face {
   font-family: 'Baloo-Regular';
   src: url(~@/assets/fonts/Baloo-Regular-webfont.woff) format('woff');
}

.admin,
.admin * {
  background-color: #ffdfff !important;
  background: #ffdfff !important;
}

.has-error {
  @apply tw-border-2 tw-border-custom-red;
}

.btn {
  @apply tw-rounded-full tw-uppercase tw-font-normal tw-shadow tw-cursor-pointer tw-select-none;
  transition: all 400ms ease;
}

.btn:focus {
  @apply tw-outline-none;
  /* @apply tw-shadow-outline tw-bg-blue-100; */
}

.btn:hover {
  @apply tw-shadow-xl tw-text-white tw-underline;
}

.btn-icon {
  @apply tw-text-sm;
}

.btn-sm {
  @apply tw-px-3 tw-py-1 tw-text-sm;
}

.btn-sm:hover {
  @apply tw-shadow-lg !important;
}

.btn-lg {
  @apply tw-px-5 tw-py-3 tw-text-sm;
}

@screen lg {
  .btn-icon,
  .btn-lg {
    @apply tw-text-lg;
  }
}

@screen xl {
  .btn-icon {
    @apply tw-text-base;
  }

  .btn-lg {
    @apply tw-px-8 tw-py-3 tw-text-xl;
  }
}

.btn-gradient {
  @apply tw-bg-gradient-tb tw-text-white;
}

.btn-gradient:active {
  @apply tw-bg-btn-focus !important;
}

.btn-gradient-lr {
  @apply tw-bg-gradient-lr tw-text-white;
}

.btn-gradient2-lr {
  @apply tw-bg-gradient2-lr tw-text-white;
}

.btn-gradient:active {
  @apply tw-bg-btn-focus !important;
}

.btn-white {
  @apply tw-bg-white tw-text-custom-blue;
}

.btn-white:active {
  @apply tw-bg-custom-midgray tw-text-custom-blue tw-shadow-inner;
}

.btn-red {
  @apply tw-bg-red-gradient-tb tw-text-white;
}

.btn-circle {
  @apply tw-rounded-full tw-flex tw-justify-center tw-items-center tw-cursor-pointer;
  transition: all 300ms linear;
}

.btn-circle:hover {
  @apply tw-shadow-lg tw-no-underline;
}

.btn-circle-sm {
  @apply tw-w-6 tw-h-6;
}

.btn-circle-md {
  @apply tw-h-10 tw-w-10;
}

.btn-circle-lg {
  @apply tw-w-12 tw-h-12;
}

.btn-circle-transparent:hover {
  @apply tw-bg-white tw-text-custom-darkgray tw-shadow-lg;
}

.btn-circle-white {
  @apply tw-bg-white tw-text-custom-darkgray tw-shadow-lg;
}

.btn-circle-transparent {
  @apply tw-bg-custom-white-10 tw-text-white;
}

.btn-circle-teal {
  @apply tw-bg-custom-teal;
  @apply tw-text-white !important;
}

.btn-circle-teal:hover {
  @apply tw-bg-custom-midgray;
  @apply tw-text-custom-teal !important;
}

.btn-circle-teal:active {
  @apply tw-text-custom-darkgray;
}

.btn-rounded-blue {
  @apply tw-text-white tw-bg-gradient-fb tw-border tw-border-transparent;
}

.btn-rounded-blue:hover {
  @apply tw-text-custom-lightgray;
}

.btn-rounded-blue:active {
  @apply tw-border tw-border-black;
}

.btn-squared-rounded-blue {
  @apply tw-text-white !important;
  @apply tw-cursor-pointer tw-bg-custom-teal tw-font-bold tw-py-2 tw-px-4 tw-rounded;
}

.btn-squared-rounded-blue:hover {
  @apply tw-bg-custom-teal;
}

.btn-squared-rounded-blue:focus {
  @apply tw-outline-none tw-shadow-outline;
}

.heading {
  @apply tw-text-2xl tw-font-baloo tw-font-bold tw-leading-tight tw-text-custom-blue;
}

.heading-white {
  @apply tw-text-2xl tw-font-baloo tw-font-bold tw-leading-tight tw-text-white;
}

.heading-black {
  @apply tw-text-xl tw-font-baloo tw-font-bold tw-leading-tight tw-text-black;
}

.paragraph {
  @apply tw-leading-tight;
}

.ns-container {
  @apply tw-w-11/12 tw-mx-auto;
}

@screen sm {
  .heading,
  .heading-white {
    @apply tw-text-3xl;
  }
}

@screen md {
  .ns-container {
    width: 750px;
    @apply tw-px-5;
  }
}

@screen lg {
  .ns-container {
    @apply tw-w-11/12;
  }
  .heading,
  .heading-white {
    @apply tw-text-4xl;
  }
}

@screen xl {
  .ns-container {
    width: 1200px;
  }
}
</style>
